module.exports = __webpack_public_path__ + "static/media/challenge_pro.f3d7d7ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/badges/challenge_pro.png
// module id = 1064
// module chunks = 0